import { call, put, takeLatest, all, select, delay } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchEnergyGrid({ energyGridParams }) {
  let token = true,
    getToken;
  while (token) {
    try {
      yield put(Actions.setLoader({ showLoader: true }));
      const { data } = yield call(api.get, {
        route:
          `Energy/factory/` +
          energyGridParams.factoryId +
          `/` +
          energyGridParams.groupId +
          `/` +
          energyGridParams.state,
      });
      const energyGrid = data;
      yield put(Actions.setEnergyGrid({ energyGrid }));
      yield put(Actions.setLoader({ showLoader: false }));

      yield delay(60000, true);
      getToken = state => state.services.common.getIn(['ajaxCallLoopEnergy']);
      token = yield select(getToken);
    } catch (err) {
      console.warn(err); // Handle exception
      yield put(Actions.setLoader({ showLoader: false }));
    }
  }
}
export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ENERGY_GRID, fetchEnergyGrid)]);
}
